export default __webpack_public_path__ + "static/media/send.4eae2a00.svg";